import type React from "react"
import type { Control } from "react-hook-form"
import { Controller, useFieldArray } from "react-hook-form"

import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/input"
import { TextArea } from "@/components/ui/textarea"

interface IStudentAccessibilityProps {
  control: Control
  name: string
}

const StudentAccessibility: React.FC<IStudentAccessibilityProps> = ({
  control,
  name,
}) => {
  const { fields, append } = useFieldArray({
    control: control,
    name: name,
  })

  return (
    <div className="pt-4">
      <Label className="pb-4">
        Are there student accessibility/support considerations that we can to
        take into account?
      </Label>
      {fields.map((item, index) => (
        <div key={item.id} className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <Controller
              control={control}
              name={`${name}.${index}.context`}
              render={({ field: { value, onChange, onBlur, ref } }) => (
                <TextArea
                  ref={ref}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  isRequired
                  label="Context"
                  hint="This is a hint text to help user."
                  rows={2}
                />
              )}
            />
          </div>
          <div>
            <Label className="pb-4">Accommodation measures</Label>
            <Checkbox label="Sound" size="sm" />
            <Checkbox label="Flashing lights" size="sm" />
            <Checkbox label="Extended breaks" size="sm" />
          </div>
        </div>
      ))}
      <div className="flex justify-center">
        <Button
          color="primary"
          size="sm"
          onClick={() => append({ context: "" })}
        >
          Add
        </Button>
      </div>
    </div>
  )
}

export default StudentAccessibility
